export default function SkullSpaceMemberLogo() {
    return (
        <img
            className="bar-item-skull"
            src="skullspace-round.svg"
            alt="SkullSpace member logo"
        />
    );
}
